import { ApiResponse } from "../../contracts/responses/ApiResponse";
import { HttpClient } from "../../infrastructure/http/HttpClient";


export {};


export class CoreService {

  httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_APIURL);
    this.httpClient.addHeader('x-api-key', `${process.env.REACT_APP_APIKEY}`);
    this.httpClient.addHeader('x-version', `${process.env.REACT_APP_VERSION}`);
  }

  async fetchTermsAndConditions(): Promise<any> {
    try {
      const response = await this.httpClient.get<ApiResponse<any>>(`/api/v1/backoffice/compliance/documents?name=${process.env.REACT_APP_DOCUMENT}`);

      if (response?.data?.status !== 200) {
        throw new Error(response.data.payload);
      }

      return Promise.resolve(response.data.payload);
    }
    catch (error: any) {
      return Promise.reject(error);
    }
  }

}

